import { Language } from '@/entities';

export const LANGUAGE_OPTIONS = [
  {
    value: Language.en,
    label: 'English',
  },
  {
    value: Language.pt,
    label: 'Português',
  },
  {
    value: Language.es,
    label: 'Español',
  },
  {
    value: Language.uk,
    label: 'Українська',
  },
];
